module.exports = __webpack_public_path__ + "static/media/etiquette-bg.d963804d.png";